import React from 'react';
import classNames from 'classnames';

import { Member } from '@wix/members-domain-ts';

import styles from './action-button.scss';
import withTranslate from '../../hoc/with-translate';
import { Button } from '../button';

interface Props {
  t: TranslationFunction;
  member: Member;
  linkClassName?: string;
  currentMemberUid?: string;
  containerClassName?: string;
  goToMemberPage: (id: string) => void;
  followOrUnfollow: (id: string) => void;
}

class ActionButtonComponent extends React.Component<Props> {
  renderFollowOrUnfollow() {
    const { t, member, linkClassName, followOrUnfollow } = this.props;

    const classes = classNames(
      member.isSubscribed
        ? ['ma-secondary-button', 'ma-members-button-font-secondary', linkClassName || '']
        : ['ma-primary-button', 'ma-members-button-font-primary', linkClassName || ''],
    );

    return (
      <Button
        dataHook="action-button"
        onClick={() => followOrUnfollow(member.uid)}
        className={classNames(classes, styles.btn, 'ma-followers-buttons-corner-radius', 'ma-ff-button-border')}
      >
        {member.isSubscribed ? t('profile-widget.unfollow') : t('profile-widget.follow')}
      </Button>
    );
  }

  renderLinkToMyProfile() {
    const { member, goToMemberPage, t, linkClassName } = this.props;
    const classes = classNames([linkClassName, 'ma-secondary-button', 'ma-members-button-font-secondary']);
    return (
      <Button
        dataHook="action-button"
        onClick={() => goToMemberPage(member.uid)}
        className={classNames(classes, styles.btn, 'ma-followers-buttons-corner-radius', 'ma-ff-button-border')}
      >
        {t('members-page.my-profile')}
      </Button>
    );
  }

  render() {
    const { member, currentMemberUid, containerClassName } = this.props;
    return (
      <div className={containerClassName}>
        {member.uid === currentMemberUid ? this.renderLinkToMyProfile() : this.renderFollowOrUnfollow()}
      </div>
    );
  }
}

export const ActionButton = withTranslate(ActionButtonComponent);
